<template>
  <component :is="component" />
</template>

<script setup lang="ts">
const locale = useI18n().locale;   

const component = defineAsyncComponent(() =>
  import(`./${locale.value}/index.vue`)
);

</script>
